import styled from "styled-components";

const Footer = styled.div`
    position: relative;
    bottom: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin-top: 16px;
`;

export default Footer;
